import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getApp } from '../../reducers/create-app/duck';
import { getAppCampaigns, patchCampaign, annulPatchError } from '../../reducers/create-campaign/duck';
import {
  getChartReport,
  getChartCompareReport,
  getTableReport,
  resetChartCompareReport,
  getExport,
  resetChartReport,
  getAllReport,
  getCurrentDate,
  setEvents,
  getEvents,
  updateEvents,
  setAdminTable,
  setUserTable,
  getAdminTable,
  updateAdminTable,
  updateEventTableAdmin,
  deleteNotActualTableAdmin,
  updateDatePicker, getUserTable, updateUserTable, updateEventTableUser, deleteNotActualTableUser,
} from '../../reducers/dashboard/duck';

import MainPanel from './MainPanel';

const mapStateToProps = ({
  campaignStore: {
    getAppCampaignsStatus,
    getAppCampaignsError,
    currentAppCampaigns,
    patchCampaignStatus,
    patchCampaignError,
  },
  userStore: {
    sidebarStatus,
    profile: {
      role: userRole,
    },
    id: userId,
  },
  createAppStore: {
    currentEditableApp,
    getAppStatus,
  },
  dashboardStore: {
    chartReport,
    chartCompareReport,
    tableReport,
    currentDate,
    currentEvents,
    accessedEvents,
    adminTable,
    userTable,
    datePicker,
  },
}) => ({
  getAppCampaignsStatus,
  getAppCampaignsError,
  currentAppCampaigns,
  userRole,
  chartReport,
  chartCompareReport,
  tableReport,
  currentEvents,
  accessedEvents,
  patchCampaignStatus,
  patchCampaignError,
  currentEditableApp,
  getAppStatus,
  userId,
  currentDate,
  adminTable,
  userTable,
  sidebarStatus,
  datePicker,
});

const mapDispatchToProps = {
  getAppCampaigns,
  getChartReport,
  getAllReport,
  getChartCompareReport,
  getTableReport,
  patchCampaign,
  annulPatchError,
  resetChartCompareReport,
  getExport,
  getApp,
  resetChartReport,
  getCurrentDate,
  getEvents,
  updateEvents,
  setEvents,
  getAdminTable,
  setAdminTable,
  updateAdminTable,
  updateEventTableAdmin,
  deleteNotActualTableAdmin,
  updateDatePicker,
  setUserTable,
  getUserTable,
  updateUserTable,
  updateEventTableUser,
  deleteNotActualTableUser,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainPanel));



// WEBPACK FOOTER //
// ./src/containers/MainPanel/index.js